import React, { useState } from 'react';
import { formatFileSize } from '../utils/noteCrypto';
import './NoteItem.css';

const NoteItem = ({ 
  note, 
  onSelect, 
  onEdit, 
  onDelete,
  isEditing = false
}) => {
  const [showActions, setShowActions] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const itemId = note.note_id;
  const itemTitle = note.title || 'Untitled';
  const itemContent = note.content || '';
  const itemSize = note.size || 0;
  const itemDate = note.updated_at;

  // 格式化日期为具体的年月日时分秒 (UTC时间)
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'UTC'
    }) + ' UTC';
  };

  // 截取内容预览
  const getContentPreview = (content, maxLength = 80) => {
    if (!content) return 'No content';
    return content.length > maxLength 
      ? content.substring(0, maxLength) + '...'
      : content;
  };

  // 处理选择
  const handleSelect = () => {
    if (onSelect) {
      onSelect(note);
    }
  };

  // 处理编辑
  const handleEdit = (e) => {
    e.stopPropagation();
    if (onEdit) {
      onEdit(itemId, itemTitle, itemContent);
    }
  };

  // 处理删除
  const handleDelete = async (e) => {
    e.stopPropagation();
    
    if (isDeleting) return;
    
    const confirmMessage = 'Are you sure you want to delete this note? This action cannot be undone.';
    
    if (window.confirm(confirmMessage)) {
      setIsDeleting(true);
      try {
        await onDelete(itemId);
      } catch (error) {
      } finally {
        setIsDeleting(false);
      }
    }
  };


  // 处理鼠标进入
  const handleMouseEnter = () => {
    setShowActions(true);
  };

  // 处理鼠标离开
  const handleMouseLeave = () => {
    setShowActions(false);
  };

  return (
    <div 
      className={`note-item ${isEditing ? 'editing' : ''}`}
      onClick={handleSelect}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="note-item-header">
        <div className="note-title">
          <h4>{itemTitle}</h4>
          {/* 将元信息移到标题正下方 */}
          <div className="note-meta">
            <span className="note-date">
              {formatDate(itemDate)}
            </span>
            <span className="note-size">
              {formatFileSize(itemSize)}
            </span>
          </div>
        </div>
        
        <div className={`note-actions ${showActions ? 'visible' : ''}`}>
          {onEdit && (
            <button
              onClick={handleEdit}
              className="action-button edit-button"
              title="Edit"
            >
              ✏️
            </button>
          )}
          
          {onDelete && (
            <button
              onClick={handleDelete}
              className="action-button delete-button"
              title="Delete"
              disabled={isDeleting}
            >
              {isDeleting ? '...' : '🗑️'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoteItem;
